import React from "react";
import { Modal } from "react-bootstrap";
import "../../style/modal.css";
import agentImg from "../../images/dummy_person.png";
import { imgBaseUrl } from "../../Const";

export default function ContectModal({ show, onHide, data }) {
    return (
        <Modal size="md" aria-labelledby="contained-modal-title-vcenter" className="modal-details" show={show} centered>
            <Modal.Header className="justify-content-between">
                <Modal.Title>Call the agent for more information.</Modal.Title>
                <button type="button" onClick={onHide} className="close-icon-style">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                    </svg>
                </button>
            </Modal.Header>
            <Modal.Body>
                <div className="dialog-content">
                    <div className="dialog-subtitle">
                        <div className="dlg-img agent_img">
                            <img
                                src={data?.path ? imgBaseUrl + data?.path : agentImg}
                                className="img-fluid"
                                alt={data.name}
                                loading="lazy"
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null;
                                    currentTarget.src = `${agentImg}`;
                                }}
                            />
                        </div>
                        <div className="dlg-cnt">
                            <h5>{data?.name ? data.name : "Agent"}</h5>
                            <span>{data?.agency?.name ? data?.agency?.name : ""}</span>
                        </div>
                    </div>
                    {/* <div className="dialog-text">
                        <p>
                            Please remember to mention the property reference <b>{data?.brnNumber ? data?.brnNumber : "ABCD123"}</b> when you call.
                        </p>
                    </div> */}
                    <div className="dialog-number mt-3">
                        <button type="button">
                            <h6>+{data?.contactNumber ? data?.contactNumber : "971 1234 5678 123"}</h6>
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
